import { Component } from '@angular/core';
import { IWizItemRenderer } from '@wizeoo/akm-component-lib';
import { ChronocodeVO } from '@wizeoo/akm-common-lib';

@Component({
  selector: 'chronocode-small-renderer',
  templateUrl: './chronocode-small.renderer.html',
})
export class ChronocodeSmallRenderer implements IWizItemRenderer<null, ChronocodeVO> {
  public data: any; // datas from owner
}
